<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터 기본정보를 등록하고, 관리한다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="이름 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['업종선택', ...bizTypeList]"
                    :select-value="['', ...bizTypeValueList]"
                    :selected-value="bizType"
                    @update:set="(val) => (bizType = val)"
                ></select-form>
                <select-form
                    :select-data="['센터구분', ...centerTypeList]"
                    :select-value="['', ...centerTypeValueList]"
                    :selected-value="centerType"
                    @update:set="(val) => (centerType = val)"
                ></select-form>
                <select-form
                    :select-data="['계약상태', ...statusTypeList]"
                    :select-value="['', ...statusTypeValueList]"
                    :selected-value="status"
                    @update:set="(val) => (status = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>
        <div class="com-btn-area">
            <div class="left-box">
                <button class="com-btn excel" @click="excelDownload">엑셀다운로드</button>
            </div>
            <div class="right-box">
                <router-link class="com-btn blue" to="/madmin/business/center/edit">센터등록</router-link>
            </div>
        </div>
        <div class="com-table-content">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 220px" />
                    <col style="width: 140px" />
                    <col style="width: 126px" />
                    <col style="width: 100px" />
                    <col style="width: 92px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 300px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button @click="(sortType = sortType === 'ASC' ? 'DESC' : 'ASC'), onSearchList()">
                                등록일
                            </button>
                        </th>
                        <th>센터명</th>
                        <th>접속</th>
                        <th>업종</th>
                        <th>센터구분</th>
                        <th>최고관리자명</th>
                        <th>최고관리자 연락처</th>
                        <th>센터 전화번호</th>
                        <th>센터 주소</th>
                        <th>계약상태</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(center, index) in centerList" :key="`C${index}`">
                        <td>{{ center.createdAt | timestampFilter }}</td>
                        <td>
                            <router-link :to="`/madmin/business/center/edit/${center.id}`" class="link">
                                {{ center.centerName }}
                            </router-link>
                        </td>
                        <td>
                            <button class="com-btn small blue" @click="fetchStaffList(center.id, center.centerName)">
                                직원보기
                            </button>
                        </td>
                        <td>{{ convertBizTypeFormat(center.bizType) }}</td>
                        <td>{{ center.centerType == 'M' ? '본점' : '지점' }}</td>
                        <td>{{ center.contactUserName }}</td>
                        <td>{{ center.contactUserTel | phoneNumberFilter }}</td>
                        <td>{{ center.telNo | phoneNumberFilter }}</td>
                        <td>{{ center.address }}</td>
                        <td>{{ center.statusCd == 'X' ? '종료' : '유효' }}</td>
                    </tr>
                    <tr v-if="centerList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    :selected-value="pagingInfo.limit"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event, 'center')"
        ></b-pagination>

        <div v-show="accountPop" class="layer-pop">
            <div class="view-content">
                <div class="top-area">
                    <span class="title">{{ staffCenterName }}</span>
                    <span class="txt">클릭 시, 해당 계정으로 접속 전환됩니다.</span>
                    <button class="close" @click="closePopupStaffList"><span class="blind">팝업 닫기</span></button>
                </div>
                <loading-spinner v-if="isLoading"></loading-spinner>
                <div v-else class="scroll-area com-scroll-y">
                    <ul class="select-photo-list">
                        <li
                            v-for="staff in staffList"
                            :key="`S${staff.c_center_staff_id}`"
                            @click="onClickStaff(staff.c_center_id, staff.c_center_staff_id, staff.c_status_cd)"
                        >
                            <a href="#">
                                <img :src="`${staff.c_img_url}`" alt="" @error="imageUrlAlt" />
                                <span class="name">{{ staff.c_namee }}</span>
                                <span class="tel">{{ staff.c_phone | phoneNumberFilter }}</span>
                                <span class="type">{{ staff.r_role_nm }}</span>
                                <span class="detail">{{ staff.staffTeamsStr }}</span>
                            </a>
                        </li>
                        <li v-if="staffList.length === 0" class="no-msg">
                            <span>등록된 직원이 없습니다.</span>
                        </li>
                    </ul>
                    <b-pagination
                        v-model="staffListPagingInfo.page"
                        :per-page="staffListPagingInfo.limit"
                        :total-rows="staffListPagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="handlerPagenation($event, 'staff')"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../../assets/js/api';
import moment from 'moment';
import EventBus from '../../../../assets/js/eventBus';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import XLSX from 'xlsx';
import { addDashPhoneNumber, centerBizType, timestampToDate } from '@/assets/js/excelCommon.js';
import jwt_decode from 'jwt-decode';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'businessCenterList',
    components: { LoadingSpinner },
    props: {},
    watch: {
        bizType(newValue) {
            this.bizType = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        centerType(newValue) {
            this.centerType = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        status(newValue) {
            this.status = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        period(newValue) {
            // 검색 기간 설정 변수
            this.period = newValue;
            this.pagingInfo.page = 1;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.startDate = this.initStartDate();
                this.endDate = this.initEndDate();
            }
            this.onSearchList();
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    data() {
        return {
            isLoading: false,
            accountPop: false,
            value: '',
            centerList: {},
            pagingInfo: { ...pagingInfo }, // 센터 목록 페이징 정보
            startDate: '2015-01-01',
            endDate: moment().format('YYYY-MM-DD'),
            bizType: '',
            centerType: '',
            status: '',
            searchStr: '',
            period: '12M',
            bizTypeList: ['헬스장', '필라테스', '요가', 'PT샵', '스포츠시설', '뷰티', '기타'],
            bizTypeValueList: ['H', 'F', 'Y', 'P', 'S', 'B', 'E'],
            centerTypeList: ['본점', '지점'],
            centerTypeValueList: ['M', 'C'],
            statusTypeList: ['종료', '유효'],
            statusTypeValueList: ['X', 'O'],
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            staffList: {}, // 직원 목록
            staffCenterId: '', // 직원 Center Id
            staffCenterName: '', // 직원 Center Name
            staffListPagingInfo: {
                // 직원 목록 페이징 정보
                page: 1,
                limit: 10,
            },
            sortType: 'ASC',
            count: 0,
        };
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            this.pagingInfo.page = 1;
            this.onSearchList();
        } else {
            alert('권한이 없습니다.');
            this.$router.push('/care/login');
        }
    },
    methods: {
        // 엑셀 다운로드
        async excelDownload() {
            const { startDate, endDate, bizType, centerType, status, searchStr } = this;
            const { data } = await api.get('/admin/api/center', {
                params: {
                    startDate,
                    endDate,
                    bizType,
                    centerType,
                    status,
                    searchStr,
                    page: 1, // 페이지
                    limit: 10000, // 한 목록에 표출되는 건수
                },
            });

            const excelDownloadArray = [];
            data.items.forEach((center) => {
                const temp = {};
                temp['계약일'] = timestampToDate(center.createdAt);
                temp['센터명'] = center.centerName;
                temp['업종'] = centerBizType(center.bizType);
                temp['센터구분'] = center.centerType === 'M' ? '본점' : '지점';
                temp['담당자명'] = center.contactUserName;
                temp['담당자 연락처'] = addDashPhoneNumber(center.contactUserTel);
                temp['센터 전화번호'] = addDashPhoneNumber(center.telNo);
                temp['센터 주소'] = center.address;
                temp['계약상태'] = center.statusCd === 'X' ? '종료' : '유효';
                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 20 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 15 },
                { wch: 15 },
                { wch: 60 },
                { wch: 10 },
            ];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '센터 목록');
            XLSX.writeFile(wb, `센터 관리 ${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 센터 검색 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                this.setPageParams(data, 'center');
                this.centerList = data.items;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 센터 목록 조회 API
        getCenterList() {
            const { startDate, endDate, bizType, centerType, status, searchStr } = this;
            // 스웨거 검색: 센터목록 검색
            return api.get('/admin/api/center', {
                params: {
                    startDate,
                    endDate,
                    bizType,
                    centerType,
                    status,
                    searchStr,
                    ...this.pagingInfo,
                    sortType: this.sortType,
                },
            });
        },

        // 이벤트 발생시 키워드 길이 체크
        onEventSearch(e) {
            if (this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },

        // 페이징 Param 설정
        setPageParams(data, pagingType) {
            if (pagingType === 'center') {
                this.pagingInfo.totalPages = data.meta.totalPages;
                this.pagingInfo.page = data.meta.currentPage;
                this.pagingInfo.totalItems = data.meta.totalItems;
                this.pagingInfo.itemCount = data.meta.itemCount;
            } else if (pagingType === 'staff') {
                this.staffListPagingInfo.totalPages = data.meta.totalPages;
                this.staffListPagingInfo.page = data.meta.currentPage;
                this.staffListPagingInfo.totalItems = data.meta.totalItems;
                this.staffListPagingInfo.itemCount = data.meta.itemCount;
            }
        },

        // 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'center') {
                this.pagingInfo.page = event;
                this.onSearchList();
            } else if (pagingType === 'staff') {
                this.staffListPagingInfo.page = event;
                this.fetchStaffList(this.staffCenterId, this.staffCenterName);
            }
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },
        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            return startDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '12M';
            this.bizType = '';
            this.centerType = '';
            this.status = '';
            this.searchStr = '';
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 업종 코드 변환
        convertBizTypeFormat(bizType) {
            if (bizType == 'H') {
                return '헬스장';
            } else if (bizType == 'F') {
                return '필라테스';
            } else if (bizType == 'Y') {
                return '요가';
            } else if (bizType == 'P') {
                return 'PT샵';
            } else if (bizType == 'S') {
                return '스포츠시설';
            } else if (bizType == 'B') {
                return '뷰티';
            } else if (bizType == 'E') {
                return '기타';
            }
        },

        // 센터 직원 목록 조회 API
        getStaffList() {
            return api.get(`/admin/api/center/${this.staffCenterId}/staff/all/pagaing`, {
                params: {
                    status: 'I',
                    ...this.staffListPagingInfo,
                },
            });
        },

        // 센터 직원 목록 fetch
        async fetchStaffList(centerId, centerName) {
            this.accountPop = true;
            this.staffCenterId = centerId;
            this.staffCenterName = centerName;
            try {
                this.isLoading = true;
                const { data } = await this.getStaffList();
                this.setPageParams(data, 'staff');
                this.staffList = data.items;

                if (data.items.length !== 0) {
                    // 화면에 표시해줄 직원이 속해있는 회원팀 string 가공
                    data.items.forEach((staff, index) => {
                        if (staff.centerStaffTeams.length == 1) {
                            this.staffList[index].staffTeamsStr =
                                staff.centerStaffTeams[0].centerTeam !== null
                                    ? staff.centerStaffTeams[0].centerTeam.name
                                    : '-';
                        } else if (staff.centerStaffTeams.length == 0) {
                            this.staffList[index].staffTeamsStr = '-';
                        } else {
                            this.staffList[index].staffTeamsStr = `${staff.centerStaffTeams[0].centerTeam.name} 외 ${
                                staff.centerStaffTeams.length - 1
                            }`;
                        }
                    });
                }
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/icons/no_photo.jpg';
        },

        // '팝업 닫기' 클릭시 staff 관련 변수 초기화
        closePopupStaffList() {
            this.accountPop = false;
            this.staffList = {};
            this.staffCenterId = '';
            this.staffCenterName = '';
        },

        // 직원 보기 팝업에서 직원 클릭시 해당 직원으로 로그인
        async onClickStaff(centerId, staffId, statusCd) {
            try {
                if (statusCd !== 'I') {
                    alert('퇴사한 강사입니다.');
                    return;
                }

                this.isLoading = true;
                const { data } = await this.sendPostChangeStaff(centerId, staffId);

                // 스웨거 검색: 토큰갱신
                await api
                    .put('/admin/api/auth', {
                        accessToken: data.accessToken,
                        refreshToken: data.refreshToken,
                    })
                    .then((response) => {
                        if (response.data.accessToken) {
                            const jwtObject = jwt_decode(response.data.accessToken);

                            const retParams = { ...jwtObject };
                            retParams.accessToken = response.data.accessToken;
                            retParams.refreshToken = response.data.refreshToken;
                            retParams.centerId = retParams.cid;
                            retParams.userId = retParams.lid;
                            retParams.userName = retParams.unm;
                            retParams.roleId = retParams.rid;
                            retParams.roleName = retParams.rnm;
                            retParams.centerChains = response.data.centerChains;
                            retParams.insteadAdmin = true;

                            // localStorage.setItem('userInfo', JSON.stringify(retParams));

                            this.$store.commit('auth/loginSuccess', retParams);
                            this.$router.push({ name: 'CenterMain' });
                            window.location.reload();
                        }
                    });
            } catch (error) {
                if (error.response.data.message === '사용불가한 센터의 직원입니다.') {
                    alert('사용기간이 종료되어 사용이 불가합니다.\n핏투데이케어로 문의 해 주세요.');
                } else {
                    alert('오류가 발생했습니다.');
                }
                console.log(error.data);
                window.location.reload();
            }
        },

        // 케어직원 -> 센터직원 로그인 API 호출
        sendPostChangeStaff(centerId, staffId) {
            return api.post('/admin/api/auth/center/change-staff/login', {
                centerId,
                centerStaffId: staffId,
            });
        },
    },
};
</script>
<style lang="scss"></style>
